import { isDefined } from "@clipboard-health/util-ts";
import { useAppInfo } from "@src/appV2/lib/index";
import {
  HcfTimeclockComplianceRolloutState,
  type HcfTimeclockComplianceVideoValidationRollout,
} from "@src/appV2/Shifts/Shift/ShiftState/types";
import { isEnabledForAppVersionAndOta } from "@src/appV2/Shifts/utils/isSolveUnpaidBreaksFeatureEnabled";

export function useIsTimeclockComplianceVideoValidationEnabled(
  hcfTimeclockComplianceVideoValidationRollout?: HcfTimeclockComplianceVideoValidationRollout
): boolean {
  const { appInfo } = useAppInfo();

  if (!isDefined(hcfTimeclockComplianceVideoValidationRollout)) {
    return false;
  }

  const { state, minimalOtaVersion, minimalStoreVersion } =
    hcfTimeclockComplianceVideoValidationRollout;

  if (state !== HcfTimeclockComplianceRolloutState.ENABLED) {
    return false;
  }

  return isEnabledForAppVersionAndOta({
    minimalOtaVersion: String(minimalOtaVersion),
    minimalStoreVersion,
    appInfo,
  });
}
